export const PROTOCOL_VERSION = Object.freeze({ major: 1, minor: 0 });
